import './styles.css';
import React from 'react';
import PropTypes from 'prop-types';
import EmbeddedYouVisit from '../../../components/EmbeddedYouVisit';

class YouVisitBanner extends React.Component {
  static propTypes = {
    ipedscode: PropTypes.string,
  };

  render() {
    const { ipedscode } = this.props;

    return (
      <div className="youvisit-banner-container">
        <EmbeddedYouVisit ipedscode={ipedscode} />
      </div>
    );
  }
}

export default YouVisitBanner;
